<template>
    <div
        ref="overlay"
        :class="{ 'is-visible': isVisible }"
        class="layout-overlay"
        tabindex="-1"
        role="dialog"
        aria-modal="true"
        :aria-label="title"
    >
        <div class="layout-overlay__title">
            <button
                v-if="returnButtonVisible"
                class="btn--clear"
                @click="$emit('close')"
                aria-label="zamknij filtry "
            >
                <ArrowRightIcon height="22" class="layout-overlay__icon" />
            </button>
            <span class="h1">
                {{ title }}
            </span>
            <div class="layout-overlay__btn">
                <slot name="button" />
            </div>
        </div>

        <slot />
    </div>
</template>
<script>
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import ArrowRightIcon from '@icons/arrow-right--small.svg'

export default {
    components: {
        ArrowRightIcon
    },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        returnButtonVisible: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isVisible: this.isOpen
        }
    },
    watch: {
        isOpen(value) {
            this.isVisible = value
            if (value && this.$refs.overlay) {
                disableBodyScroll(this.$refs.overlay)
            } else {
                enableBodyScroll(this.$refs.overlay)
            }
        }
    }
}
</script>
<style lang="scss">
.layout-overlay {
    display: none;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    z-index: 20000001; // over livezilla
    padding: 15px;
    overflow: auto;

    &.is-visible {
        display: block;
    }

    &__title {
        margin-bottom: 3rem;
        display: flex;
        text-transform: uppercase;
        color: $sherpa-blue;
        align-items: center;

        a {
            color: currentColor;
        }

        span.h1 {
            text-transform: initial;
            color: #595a68;
        }
    }

    &__icon {
        transform: rotate(180deg);
        margin-right: 2rem;
    }

    &__btn {
        margin-left: auto;
    }

    .h1 {
        margin: 0;

        @media #{$media-to-sm} {
            font-size: 20px;
        }
    }

    .h3 {
        @media #{$media-to-sm} {
            font-weight: $font-weight-xbold;
            font-size: 2rem;
        }
    }

    button {
        &:focus {
            border: 2px solid black;
        }
    }

    .layout-overlay__btn {
        button {
            &:focus {
                border: 2px solid black;
                color: black;
            }
        }
    }
}
</style>
